// Public re-export
export { toaster } from '@/components/ui/toaster'

// Private import for use in this file
import { toaster } from '@/components/ui/toaster'

type CreateToastOptions = {
  id?: string
  title?: string
  description?: string
  type?: 'success' | 'error' | 'warning' | 'info' | 'loading'
  duration?: number
  closable?: boolean
  action?: {
    label: string
    onClick: () => void
  }
}

export const BASE_TOAST_OPTION: CreateToastOptions = {
  duration: 5000,
  closable: true,
}

export const SUCCESS_TOAST_OPTION: CreateToastOptions = {
  ...BASE_TOAST_OPTION,
  type: 'success',
}

export const ERROR_TOAST_OPTION: CreateToastOptions = {
  ...BASE_TOAST_OPTION,
  type: 'error',
}

export const LOADING_TOAST_OPTION: CreateToastOptions = {
  ...BASE_TOAST_OPTION,
  duration: 20000,
  closable: false,
  type: 'loading',
}

// Helper to show or update a toast by id
export function showOrUpdateToast(
  toastId: string,
  toastContent: CreateToastOptions,
) {
  // For now, just dismiss any existing toast with the same id and create a new one
  toaster.dismiss(toastId)
  toaster.create({
    ...toastContent,
    id: toastId,
  })
}
